export default __webpack_public_path__ + "static/media/power_in_your_hands.f3afddc4.png";